import { ThemeEvents } from '@theme/events';

// Reuse the native picker’s returned section; no extra requests or price calculation.
class CoffeeValueView extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.closest('.shopify-section')?.addEventListener(ThemeEvents.variantUpdate, (event) => {
      const source = event.detail?.data?.html;
      const next = source?.querySelector(`scc-coffee-value-view[data-product-id="${this.dataset.productId}"]`);
      if (next) this.replaceChildren(...Array.from(next.childNodes));
    }, { signal: this.controller.signal });
  }
  disconnectedCallback() {
    this.controller?.abort();
  }
}
if (!customElements.get('scc-coffee-value-view')) {
  customElements.define('scc-coffee-value-view', CoffeeValueView);
}
